import { render, staticRenderFns } from "./StudentHistoryHeader.vue?vue&type=template&id=0f731552&scoped=true&lang=pug&"
import script from "./StudentHistoryHeader.vue?vue&type=script&lang=ts&"
export * from "./StudentHistoryHeader.vue?vue&type=script&lang=ts&"
import style0 from "./StudentHistoryHeader.vue?vue&type=style&index=0&id=0f731552&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f731552",
  null
  
)

export default component.exports